import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import { useOrganisationTones } from "../hooks/useOrganisationTones";
import { useTaskpaneTelemetry } from "../telemetry/useTaskpaneTelemetry";

type Props = {
  isLoading: boolean;
  onSelectTone(toneId: string): void;
};

export function AdjustToneList({ isLoading, onSelectTone }: Props) {
  const { trackReceivableToneAdjusted } = useTaskpaneTelemetry();
  const { tones, isError, isLoading: isTonesLoading } = useOrganisationTones();

  if (isError) {
    return null;
  }

  return (
    <Box sx={{ minWidth: 160, py: 1 }}>
      <Typography variant="h3" sx={{ px: 2, pb: 1 }}>
        Adjust tone
      </Typography>
      {isTonesLoading ? (
        <List dense>
          {[1, 2, 3].map((i) => (
            <ListItemButton key={i} disabled>
              <Skeleton width="80%" height={24} />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <List dense>
          {tones?.map((tone) => (
            <ListItemButton
              key={tone.id}
              onClick={() => {
                trackReceivableToneAdjusted({ tone_id: tone.id });
                onSelectTone(tone.id);
              }}
              disabled={isLoading}
            >
              <ListItemText primary={tone.name} />
            </ListItemButton>
          ))}
        </List>
      )}
    </Box>
  );
}
